import React, { useEffect, useState, useCallback } from "react";
import Layout from "../../layout/Layout";
import { useAuth } from "../../context/AuthContext";
import {
  getAdminSettings,
  updateAdminSettings,
} from "../../../api/mailSettingsApi";
import { Card, Form, Button, Spinner } from "react-bootstrap";

function MailSettingsPage() {
  const { user } = useAuth();

  const [form, setForm] = useState({
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  // SETTINGS YÜKLEME
  const loadSettings = useCallback(async () => {
    try {
      setLoading(true);
      const res = await getAdminSettings();
      const data = res.data?.data || {};
      console.log(data,"1212")

      setForm({
        email: data.email || "",
        password: data.password || "",
      });
    } catch (err) {
      console.error(err);
      alert("Ayarlar alınamadı!");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadSettings(); // user kontrolü gereksiz hale getirildi
  }, [loadSettings]);

  const handleSave = async () => {
    try {
      setSaving(true);
      await updateAdminSettings(form);
      alert("Ayarlar başarıyla güncellendi!");
    } catch (err) {
      console.error(err);
      alert("Ayarlar kaydedilemedi!");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Layout>
      {!user ? (
        <div className="text-center mt-5">Giriş yapılmadı.</div>
      ) : (
        <div className="container mt-4">
          <div className="row">
            <div className="col-12 col-md-4">

              <Card className="shadow-sm">
                <Card.Body>
                  <Card.Title className="mb-3">
                    Mail Gönderim Ayarları
                  </Card.Title>

                  {loading ? (
                    <Spinner animation="border" />
                  ) : (
                    <>
                      <Form.Group className="mb-3">
                        <Form.Label>Gönderici Email</Form.Label>
                        <Form.Control
                          type="email"
                          value={form.email}
                          onChange={(e) =>
                            setForm({ ...form, email: e.target.value })
                          }
                          placeholder="Örn: goktasreminder@gmail.com"
                        />
                      </Form.Group>

                      <Form.Group className="mb-3">
                        <Form.Label>Email Şifresi</Form.Label>
                        <Form.Control
                          type="text"
                          value={form.password}
                          onChange={(e) =>
                            setForm({ ...form, password: e.target.value })
                          }
                          placeholder="Google App Password"
                        />
                      </Form.Group>

                      <Button
                        variant="primary"
                        onClick={handleSave}
                        disabled={saving}
                      >
                        {saving ? "Kaydediliyor..." : "Kaydet"}
                      </Button>
                    </>
                  )}
                </Card.Body>
              </Card>

            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}

export default MailSettingsPage;
